import { Box, Typography } from "@mui/material";
import PageHeader from "../../components/common/PageHeader";

export default function Reports() {

  return (
    <Box className="page">

      <PageHeader title="Accounting Reports" />

      <Typography>
        Reports will appear here (P&L, Cashflow, Expenses)
      </Typography>

    </Box>
  );
}